module.exports = __webpack_public_path__ + "img/store-logo.786b74f2.png";